import { action, observable } from "mobx";
import NestStore from "~/stores/NestStore";
import Immersive3dTourProjectRepository from "~/repository/Immersive3dTour/Immersive3dTourProjectRepository";
import Immersive3dTourProject from "~/models/Immersive3dTour/Immersive3dTourProject/Immersive3dTourProject";

class Immersive3dTourProjectStore extends NestStore {
  /**
   * @property {Immersive3dTourProject|null}
   */
  @observable immersive3dTourProject = null;

  /**
   * @property {number|null}
   */
  @observable tourId = null;

  /**
   * @property {Immersive3dTourProjectRepository|null}
   */
  immersive3dTourProjectRepository = null;

  constructor() {
    super();

    this.immersive3dTourProjectRepository = new Immersive3dTourProjectRepository();
  }

  @action
  load() {
    this.isLoading = true;

    return Promise.all([this.getOne()]).finally(() => {
      this.isLoading = false;
    });
  }

  @action
  getOne() {
    return this.immersive3dTourProjectRepository.fetchOne(this.tourId).then(response => {
      this.immersive3dTourProject = new Immersive3dTourProject(response.data.immersive3dTourProject);
    });
  }

  findPanoramaById(panoramaId) {
    const { panos } = this.immersive3dTourProject;

    const panorama = panos.find(item => item.id === panoramaId);

    if (typeof panorama !== "undefined") {
      return panorama;
    }

    return null;
  }
}

export default Immersive3dTourProjectStore;
